<template>
  <div id="home" class="home" style="min-width: 1040px;">
    <div class="swiper">
      <swiper :options="swiperOption" class="swiper-menu">
        <swiper-slide>
          <div class="home-img-log">
            <img src="./images/home001.png" alt />
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="home-img-log">
            <img src="./images/home002.png" alt />
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="home-img-log">
            <img src="./images/reply.png" alt />
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="home-img-log">
            <img src="./images/home004.png" alt />
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="home-img-log">
            <img src="./images/home005.png" alt />
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <div class="img-btm-text">
        <div class="btm-text-minde">
          <div class="text-num">
            <p :style="transform">0</p>
            <p :style="transform">1</p>
          </div>个目标 实现客户利润最大化
        </div>
        <div class="btm-text-minde">
          <div class="text-num">
            <p v-for="item in upList1" :style="transform1" :key="item">{{item}}</p>
          </div>年 资深财税行业经验
        </div>
        <div class="btm-text-minde">
          <div class="text-num">
            <p v-for="item in upList2" :key="item" :style="transform2">{{item}}</p>
          </div>数千位客户的信赖之选
        </div>
      </div>
    </div>
    <div class="service">
      <div class="service-mob">
        <h2 class="service-h2">中税服务 · 品质保证</h2>
        <div class="service-img">
          <div class="service-item">
            <img src="./images/蒙版组 33.png" alt />
            <div class="service-text">
              <h4>注册注销</h4>
              <p>十年经验，全程代办注册注销，不成功全额退费</p>
            </div>
          </div>
          <div class="service-item">
            <img src="./images/蒙版组 12.png" alt />
            <div class="service-text">
              <h4>代理记账</h4>
              <p>服务满意专业性强，95%以上客户续签率，消费者满意单位</p>
            </div>
          </div>
          <div class="service-item">
            <img src="./images/蒙版组 34.png" alt />
            <div class="service-text">
              <h4>审计报告</h4>
              <p>注会注税团队，资质齐全价格优惠，入驻行政中心</p>
            </div>
          </div>
          <div class="service-item">
            <img src="./images/蒙版组 35.png" alt />
            <div class="service-text">
              <h4>税收合规安排</h4>
              <p>只做靠谱的，实实在在能落地的税收合规安排</p>
            </div>
          </div>
          <div class="service-item">
            <img src="./images/蒙版组 36.png" alt />
            <div class="service-text">
              <h4>高新申报</h4>
              <p>申报和审计一站式服务，享优惠政策和政府补贴</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="advantage">
      <div class="advantage-img">
        <img src="./images/23(1).png" alt />
        <div class="advantage-title">
          <h1>我们的优势</h1>
          <p>中税财务咨询公司+税务师事务所+会计师事务所，提供一站式服务</p>
        </div>
      </div>
    </div>
    <!-- 代理记账选择 -->
    <div class="charge-module">
      <div class="module-padding">
        <book-keeping></book-keeping>
      </div>
    </div>
    <!-- 
    margin-top: -140px;
    -->
    <div class="cancelled-father">
      <div class="cancelled">
        <div class="cancelled-title">
          <h1>注册、注销为什么选中税</h1>
        </div>
        <div class="cancelled-top">
          <div class="top-img-father top-img-father-first">
            <div class="top-img">
              <img src="./images/组 2843.png" alt />
              <p>全程代办 在线核名 省时省心省力</p>
            </div>
            <div class="top-img-bot">
              <img src="./images/组 2836.png" alt />
            </div>
          </div>
          <div class="top-img-father">
            <div class="top-img-bot">
              <img src="./images/组 2837.png" alt />
            </div>
            <div class="top-img">
              <img src="./images/组 2843.png" alt />
              <p>工商税务社保，资深专员全流程代办</p>
            </div>
          </div>
          <div class="top-img-father">
            <div class="top-img">
              <img src="./images/组 2843.png" alt />
              <p>价格透明 签约做账报税享0元注册费</p>
            </div>
            <div class="top-img-bot">
              <img src="./images/组 2838.png" alt />
            </div>
          </div>
          <div class="top-img-father">
            <div class="top-img-bot">
              <img src="./images/组 2839.png" alt />
            </div>
            <div class="top-img">
              <img src="./images/组 2843.png" alt />
              <p>注册税务师把关，涉税疑难迎刃而解</p>
            </div>
          </div>
          <div class="top-img-father">
            <div class="top-img">
              <img src="./images/组 2843.png" alt />
              <p>互联网电商、文创企业 专属法定地址挂靠</p>
            </div>
            <div class="top-img-bot">
              <img src="./images/组 2840.png" alt />
            </div>
          </div>
          <div class="top-img-father top-img-father-last">
            <div class="top-img-bot">
              <img src="./images/组 2841.png" alt />
            </div>
            <div class="top-img">
              <img src="./images/组 2843.png" alt />
              <p>十年注销成功率100%，不成功退费</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="audit-report">
      <div class="report-img">
        <img src="./images/bj14.png" alt />
      </div>
      <div class="report-card">
        <h2 class="report-card-h2">审计报告 选中税</h2>
        <div class="card-item">
          <div class="card-item-contenr">
            <div class="card-in-title">
              <p>Team</p>
            </div>
            <div class="card-in-bold">
              <p>专业团队</p>
              <span></span>
            </div>
            <div class="card-in-text">
              <p>注册会计师、注册税务师、审计师等行业高端人才组成高素质团队</p>
            </div>
          </div>
          <div class="card-item-contenr">
            <div class="card-in-title">
              <p>Qualification</p>
            </div>
            <div class="card-in-bold">
              <p>齐全的资质</p>
              <span></span>
            </div>
            <div class="card-in-text">
              <p>涵盖年报、所得税、研发、内审、高新、土增、尽职调查等各类专项审计</p>
            </div>
          </div>
          <div class="card-item-contenr">
            <div class="card-in-title">
              <p>Service</p>
            </div>
            <div class="card-in-bold">
              <p>优质的服务</p>
              <span></span>
            </div>
            <div class="card-in-text">
              <p>品牌事务所，入驻行政中心，值得您的信赖</p>
            </div>
          </div>
          <div class="card-item-contenr">
            <div class="card-in-title">
              <p>Price</p>
            </div>
            <div class="card-in-bold">
              <p>透明的价格</p>
              <span></span>
            </div>
            <div class="card-in-text">
              <p>省物价标准收费，荣获政府指定“创新券”使用服务机构</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 成功案例 -->
    <div class="successful-case">
      <!-- <div class="right-swiper">
        <img src="./images/组 2556.png" alt />
      </div>-->
      <div class="swiper-path">
        <div class="swiper-title">
          <h2>成功案例</h2>
          <!-- <p>China tax service quality assurance</p> -->
        </div>
        <div class="swiper-father">
          <swiper :options="swiperOption2" ref="mySwiper">
            <swiper-slide style="width: 100%">
              <div class="swiper-items">
                <!-- <div class="slide-flex"> -->
                <div class="swiper-img">
                  <img src="./images/组 2844.png" alt />
                </div>
                <div class="swiper-content">
                  <h3>税收合规安排 成功案例</h3>
                  <p>&nbsp;“税收合规安排”又称“合理避税”,通过对经营、投资、理财活动的事先筹划和安排，合理合法节税，实现企业利润最大化。中税在企业所得税、个人所得税等方面，有很多成功的税收合规安排经典案例。</p>
                  <div @click="onPath('/SSCH')">查看详情</div>
                </div>
              </div>

              <!-- </div> -->
            </swiper-slide>

            <swiper-slide>
              <div class="swiper-items">
                <!-- <div class="slide-flex"> -->
                <div class="swiper-img">
                  <img src="./images/lbtcg.jpg" alt />
                </div>
                <div class="swiper-content">
                  <h3>公司注销 成功案例</h3>
                  <p>&nbsp;“注册容易，注销难”。注销公司时间成本高，往往需要2个月以上；流程复杂，需要涉及工商、社保、税务、银行等各部门；特别是税务环节，需要进行近三年全税种清算；注销过程有很多遗留问题需要解决，不注销后果严重，影响股东征信。中税在注销方面有着丰富的经验，十年注销成功率100%，擅长解决疑难杂症。</p>
                  <div @click="onPath('/ZCZX/cancelled')">查看详情</div>
                </div>
              </div>

              <!-- </div> -->
            </swiper-slide>
          </swiper>
          <!-- 左右箭头 -->
          <div class="swiper-button-prev" slot="button-prev">
            <img style="width:100%;height:100%" src="./images/组 2556.png" alt />
          </div>
          <div class="swiper-button-next" slot="button-next">
            <img style="width:100%;height:100%" src="./images/组 2557.png" alt />
          </div>
        </div>
      </div>
      <!-- <div class="right-swiper">
        <img src="./images/组 2557.png" alt />
      </div>-->
    </div>
    <!-- 合作伙伴 -->
    <div class="collaborate-friend">
      <div class="friend-content">
        <div class="content-h2">
          <h2>合作伙伴</h2>
        </div>
        <div class="content-imgs">
          <img src="./images/组 2845.png" alt />
          <img src="./images/组 2846.png" alt />
          <img src="./images/组 2847.png" alt />
          <img src="./images/组 2848.png" alt />
          <img src="./images/组 2849.png" alt />
          <img src="./images/组 2850.png" alt />
          <img src="./images/组 2851.png" alt />
          <img src="./images/组 2852.png" alt />
          <img src="./images/组 2853.png" alt />
          <img src="./images/组 2854.png" alt />
          <img src="./images/组 2855.png" alt />
          <img src="./images/组 2856.png" alt />
        </div>
      </div>
    </div>
    <!-- 联系客服 -->
    <chat-case />
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import imgs from "./images/组 2829.png";
import BookKeeping from "@/common/book-keeping";
import ChatCase from "@/common/chat-case";

export default {
  name: "WaimaiSwiper",
  data() {
    return {
      swiperOption: {
        slidesPerView: "auto",
        centeredSlides: true,
        // spaceBetween: 10,
        autoplay:true, 
        loop: true,
        effect : 'fade',
        speed: 1600, //config参数同swiper4,与官网一致
        delay: 1800,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      },
      swiperOption2: {
        autoplay: true,
        speed: 1500,
        autoplayDisableOnInteraction: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      swiperPrev: {
        backgroundImage: "url(" + require("./images/组 2556.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "25px auto"
      },
      transform: {},
      transform1: {
        transition: "all 7.4s;"
      },
      transform2: {},
      upList1: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      upList2: [1000, 2000, 3000]
    };
  },
  components: {
    Swiper,
    SwiperSlide,
    BookKeeping,
    ChatCase
  },
  mounted() {
    this.transform = {
      transform: "translateY(" + -40 + "px)"
    };
    this.transform1 = {
      transform: "translateY(" + -400 + "px)"
    };
    this.transform2 = {
      transform: "translateY(" + -80 + "px)"
    };
  },
  methods: {
    onPath(path) {
      console.log(path);
      this.$router.push({path: path})
    }
  }
};
</script>
<style>
.home {
}
.swiper-slide {
  width: 100% !important;
}
</style>
<style lang="scss" module>
:root {
  // 这以下的代码是你需要的
  --swiper-theme-color: #fff;
}
</style>
<style lang="scss" scoped>
.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 60px;
}
.charge-module {
  margin: 0 auto;
  width: 1140px;
  margin-top: -17%;
  .module-padding {
    position: relative;
    width: 100%;
    padding: 0px 50px;
    background-color: white;
    border-radius: 10px;
    box-sizing: border-box;
  }
}
.home-img-log {
  width: 100%;
  img {
    width: 100%;
    vertical-align: middle;
  }
}
.swiper {
  box-shadow: 0px 1px 2px rgb(226, 226, 226);
}
.img-btm-text {
  display: flex;
  height: 50px;
  align-items: center;
  justify-content: space-evenly;
  .btm-text-minde {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    .text-num {
      height: 40px;
      color: rgb(25, 130, 250);
      font-weight: bold;
      margin-bottom: 2px;
      overflow: hidden;
      p {
        height: 40px;
        line-height: 40px;
        transition: all 1.4s;
        font-size: 25px;
        // transform: translateY(-40px);
      }
    }
  }
}

.service {
  display: flex;
  flex-direction: column;
  align-items: center;
  .service-mob {
    width: 1140px;
    margin: 0 auto;
    margin-bottom: 40px;
    // padding: 0 10%;
    .service-h2 {
      margin: 30px 0 30px 5px;
    }
    .service-img {
      display: flex;
      justify-content: space-between;
      .service-item {
        width: 21%;
        margin: 0 5px;
        box-shadow: 0 3px 5px rgb(238, 238, 238);
        img {
          width: 100%;
        }
        .service-text {
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding-bottom: 10px;
          padding-top: 10px;
          h4 {
            text-align: center;
          }
          p {
            text-align: center;
            line-height: 25px;
            margin-top: 5px;
            padding: 0 20px;
          }
        }
      }
    }
  }
}

.advantage {
  position: relative;
  .advantage-img {
    width: 100%;
    img {
      width: 100%;
    }
    .advantage-title {
      position: absolute;
      top: 50px;
      left: 200px;
      p {
        margin-top: 8px;
      }
    }
    h1 {
      font-size: 30px;
    }
    p {
      font-size: 14px;
    }
  }
}

.cancelled-father {
  display: flex;
  justify-content: center;
  .cancelled {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    .cancelled-title {
      margin: 10px 0 20px 0;
    }
    .cancelled-top {
      height: 340px;
      width: 1040px;
      margin: 0 auto;
      display: flex;
      justify-content: space-evenly;
      .top-img-father {
        display: flex;
        flex-direction: column;
        margin: 0 -80px;
        .top-img {
          width: 160px;
          position: relative;
          img {
            width: 100%;
          }
          p {
            position: absolute;
            top: 50%;
            left: 50%;
            margin-left: -60px;
            margin-top: -20px;
            width: 120px;
            text-align: center;
          }
        }
        .top-img-bot {
          width: 160px;
          margin: 20px 0;
          img {
            width: 100%;
          }
        }
      }
    }
    .top-img-father-first {
      margin-left: 0;
    }
    .top-img-father-last {
      margin-right: 0;
    }
    .cancelled-top > div:nth-child(2n) {
      align-self: flex-end;
    }
  }
}
.audit-report {
  width: 100%;
  min-width: 940px;
  margin-top: 50px;
  min-height: 404px;
  position: relative;
  .report-img {
    width: 100%;
    position: relative;
    top: 0;
    left: 0;
    img {
      width: 100%;
      min-height: 404px;
    }
  }
  .report-card {
    margin-top: 50px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    .report-card-h2 {
      margin-bottom: -50px;
      color: white;
      font-size: 26px;
    }
    .card-item {
      display: flex;
      width: 940px;
      height: 100%;
      // padding: 0 50px;
      box-sizing: border-box;
      justify-content: space-between;
      align-items: center;
      .card-item-contenr {
        width: 24%;
        height: 220px;
        display: flex;
        flex-direction: column;
        // justify-content: center;
        align-items: center;
        background-color: white;
        border-radius: 10px;
        .card-in-title {
          margin-top: 34px;
          margin-bottom: 27px;
          font-size: 25px;
          color: rgb(17, 89, 165);
        }
        .card-in-bold {
          display: flex;
          flex-direction: column;
          align-items: center;
          font-size: 15px;
          font-weight: bold;
          span {
            width: 90%;
            display: block;
            border-top: 1px solid #ccc;
            margin-top: 10px;
            margin-bottom: 10px;
          }
        }
        .card-in-text {
          width: 90%;
          text-align: center;
          font-size: 12px;
          color: rgb(129, 129, 129);
          line-height: 19px;
        }
      }
    }
  }
}

// 左右轮播切换
.swiper-button-prev {
  width: 40px;
  color: #000;
  // background-image: url('./images/组 2557.png');
  left: -40px;
}
.swiper-button-next {
  width: 40px;
  color: #000;
  right: -40px;
}
.swiper-button-prev::after {
  content: "";
  position: absolute;
  top: 0.4rem;
  left: 0.25rem;
  height: 0.5rem;
  width: 0.5rem;
  font-size: 1rem;
  // border-right: 0.1rem solid $whiteColor;
  // border-top: 0.1rem solid $whiteColor;
  border-left: 0.1rem solid transparent;
  border-bottom: 0.1rem solid transparent;
  z-index: 20;
}
.swiper-button-next::after {
  content: "";
  position: absolute;
  top: 0.4rem;
  left: 0.25rem;
  height: 0.5rem;
  width: 0.5rem;
  font-size: 1rem;
  // border-right: 0.1rem solid $whiteColor;
  // border-top: 0.1rem solid $whiteColor;
  border-left: 0.1rem solid transparent;
  border-bottom: 0.1rem solid transparent;
  z-index: 20;
}
// 成功案例
.successful-case {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 50px;
  .right-swiper {
    width: 40px;
    margin-top: 100px;
    img {
      width: 100%;
    }
  }
  .swiper-path {
    display: flex;
    width: 940px;
    position: relative;
    flex-direction: column;
    .swiper-title {
      height: 50px;
      margin-bottom: 20px;
    }
    .swiper-father {
      position: relative;
      .swiper-items {
        display: flex;
        // align-items: center;
        width: 100%;
        background: #ffffff;
        // margin-top: -30px;
        .swiper-img {
          width: 400px;
          img {
            width: 100%;
          }
        }

        @media (min-width: 900px) {
          .swiper-content {
            margin-bottom: 2.46%;
          }
        }
        @media (min-width: 1070px) {
          .swiper-content {
            margin-bottom: 2.1%;
          }
        }
        .swiper-content {
          // width: 400px;
          flex: 1;
          // height: 188px;
          // margin-bottom: 2.46%;
          padding-left: 30px;
          background: #efefef;
          box-sizing: border-box;
          h3 {
            margin: 20px 0;
          }
          div {
            width: 90px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            color: rgb(1, 139, 194);
            background: rgba(213, 219, 241, 0.6);
            border-radius: 8px;
            margin-top: 20px;
            // margin-bottom: 27px;
          }
        }
        .swiper-content:hover {
          cursor: pointer;
        }
      }
    }
  }
}
// 合作伙伴
.collaborate-friend {
  background: rgb(230, 230, 230);
  width: 100%;
  display: flex;
  align-content: center;
  justify-content: center;
  padding: 40px 0;
  .friend-content {
    width: 940px;
    box-sizing: border-box;
    .content-h2 {
      margin-bottom: 30px;
    }
    .content-imgs {
      img {
        width: 15%;
        margin-bottom: 4px;
        margin-right: 12px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/home/home.vue